"use client"

import { usePathname } from "@opensea/navigation"
import { useMountEffect, useOnChange, usePrevious } from "@opensea/ui-kit/hooks"

// Always reset scroll when navigating between pages with these base paths
const FORCE_BETWEEN = ["settings"]

// Don't reset scroll when nagivating between pages with these base paths
// E.g. /collection/slug -> /item/0x = don't reset
// E.g. /item/0x -> /collection/slug = don't reset
const IGNORE_BETWEEN = ["item", "collection", "profile"]

/**
 * https://github.com/vercel/next.js/discussions/64435 - This should be used in pages that have a top sticky element,
 * as Next.JS logic for scrolling to the top doesn't work if the page has a top sticky element.
 * e.g. Collection page, Profile page.
 */
export function ScrollToTop() {
  const pathname = usePathname()
  const previousPathname = usePrevious(pathname)

  useMountEffect(() => {
    window.scrollTo(0, 0)
  })

  useOnChange(pathname, () => {
    const basePathname = pathname.split("/")[1]
    const previousBasePathname = previousPathname?.split("/")[1]

    const shouldForce =
      FORCE_BETWEEN.includes(basePathname) &&
      FORCE_BETWEEN.includes(previousBasePathname ?? "")

    const shouldIgnore =
      IGNORE_BETWEEN.includes(basePathname) &&
      IGNORE_BETWEEN.includes(previousBasePathname ?? "")

    if (
      // If the base path is the same, don't reset, e.g. /collection/slug/items -> /collection/slug/activity
      (basePathname === previousBasePathname && !shouldForce) ||
      shouldIgnore
    ) {
      return
    }

    window.scrollTo(0, 0)
  })

  return null
}
